import "@progress/kendo-theme-bootstrap/dist/all.css";
import "./assets/Css/App.css";
import "./assets/Css/style.css";
import "bootstrap/dist/css/bootstrap.css";
import "/node_modules/react-grid-layout/css/styles.css"
import "/node_modules/react-resizable/css/styles.css"
import React, { Component, Suspense, createRef } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Welcome from "./Components/Welcome";
import SignUp from "./Auth/SignUp";
import SignIn from "./Auth/SignIn";
import { AuthMiddleware } from "./Auth/AuthMiddleware";
import { GetEarlyAccess } from "./Auth/getEarlyAccess";
import { VerifyAccount } from "./Auth/VerifyAccount";
import { RuntimeConfigPage } from "./Pages/Runtime/RuntimeConfigPage";
import RuntimePortalConfigPage from "./Components/Portal/RuntimeConfigPage";
import { SubscriptionPortalPage } from "./Pages/Subscription/SubscriptionPortalPage";
import { setShowErrorDialog } from "./API/CallApi";
import { AdminRouteRender } from "./Renderers/AdminRouteRender";
import { MsalContext } from "@azure/msal-react";
import { WorkspacePage } from "./Pages/Project/WorkspacePage";
import { PricingPage } from "./Pages/Pricing/PricingPage";
import { GlobalContextProvider } from "./Renderers/GlobalContext";
import MobilePage from "./Pages/Mobileview/MobilePage";
import WorkspaceUserPage from "./Pages/WorkspaceSettings/WorkspaceUserPage";
import WorkspaceSubscriptionPage from "./Pages/WorkspaceSettings/WorkspaceSubscriptionPage";
import { WorkspaceOrganizationRouteRender } from "./Renderers/WorkspaceOrganizationRouteRender";
import WorkspacePropertyTemplatesPage from "./Pages/WorkspaceSettings/WorkspacePropertyTemplatesPage";
import WorkspaceRecyclebinPage from "./Pages/WorkspaceSettings/WorkspaceRecyclebinPage";
import WorkspaceAppModelPage from "./Pages/WorkspaceSettings/WorkspaceAppModelPage";
import { WorkspaceProjectRouteRender } from "./Renderers/WorkspaceProjectRouteRender";
import { ConfirmationContextProvider } from "./Components/Shared/ConfirmationWithContext/ConfirmationContext";
import { WorkspaceAppModelContextProvider } from "./Context/Workspace/WorkspaceAppModelContext";
import WorkspaceInviteUsersPage from "./Pages/WorkspaceSettings/WorkspaceInviteUsersPage";
import WorkspaceProjectSettingsPage from "./Pages/WorkspaceSettings/WorkspaceProjectSettingsPage";
import WorkspaceOrganizationSettingPage from "./Pages/WorkspaceSettings/WorkspaceOrganizationSettingPage";
import WorkspacePaymentPage from "./Pages/WorkspaceSettings/WorkspacePaymentPage";
import ErrorDialog from "./Components/Shared/Error/ErrorDialog";
import { FeatureFlagProvider } from "./Context/FeatureFlag/FeatureFlagContext";
import AccessStorage from "./Pages/AccessStorage/AccessStorage";
import NoRoutes from "./Pages/404/NoRoutes";
import { getAzureUser } from "./API/User/User";
import Loader from "./Components/Shared/Loader/loader";
import SessionExpired from "./Components/SessionExpired";
import { WorkspaceCreateAppPage } from "./Pages/Project/WorkspaceCreateAppPage";
import CreateApp from "./Pages/Integrations/CopilotForDevOps/CreateApp";
import WorkspaceOrganizationPlanningPage from "./Pages/WorkspaceSettings/WorkspaceOrganizationPlanningPage";
import WorkspaceOrganizationTenantUsersPage from "./Pages/WorkspaceSettings/WorkspaceOrganizationTenantUsersPage";
import InvitationPage from "./Pages/Invitation/InvitationPage";
import { loginRequest } from "./Auth/AuthConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            innerWidth: window.innerWidth,
            showErrorDialog: false,
            error: {},
            isInternalUser: false,
            isAuthCompleted: false,
            isTokenExpired: false
        }
    }

    static contextType = MsalContext;
    refreshTokenTimeout;

    didCheckUser = createRef();

    componentDidMount = async () => {
        window.addEventListener("resize", this.resize.bind(this))
        this.resize()
        setShowErrorDialog(this.showErrorDialog);
        if (window.self === window.top)
            window.addEventListener("focus", this.handleSignOut);
        this.didCheckUser.current = false;
    }

    checkUser = async () => {
        const user = await getAzureUser(this.context);
        if (user && user.oid) {
            const email = user.emails[0];
            const whiteList = process.env.REACT_APP_WHITELIST.split(' ');
            const isInternalUser = whiteList.includes(email);
            return isInternalUser;
        }
        return false;
    }

    componentDidUpdate = async () => {
        const { inProgress, accounts } = this.context;

        if (inProgress !== "none" || this.didCheckUser.current) {
            return;
        }

        const isInIframe = window.parent !== window.self;
        const iframeParentOrigin = isInIframe ? document.referrer : "";
        const isAccessedFromRuntime = isInIframe && iframeParentOrigin === (process.env.REACT_APP_RUNTIME_URL + "/");

        try {
            if (isAccessedFromRuntime) {
                if (accounts.length === 0) {
                } else if (accounts.length > 0) {
                    await this.handleAccessToken();
                    await this.setInternalUser();
                }
            } else if (accounts.length > 0) {
                await this.handleAccessToken();
                await this.setInternalUser();
            }
        } catch (err) {
            console.error(err);
        } finally {
            this.setAuthCompleted();
        }
    }

    handleAccessToken = async () => {
        try {
            await this.getAccessToken(this.context);
            this.refreshTokenTimeout = setInterval(async () => {
                await this.getAccessToken(this.context);
            }, 5 * 60 * 1000);
        } catch (error) {
            this.setState({ isTokenExpired: true });
        }
    }

    getAccessToken = async (context) => {
        const { instance, accounts } = context;
        if (!accounts || accounts.length === 0) {
            return this.setState({ isTokenExpired: true });
        }

        const loggedInUser = accounts[0]

        const request = {
            ...loginRequest,
            account: loggedInUser
        };

        try {
            console.log("Request:", request);
            const response = await instance.acquireTokenSilent(request);
            if (response.accessToken) {
                this.setAccessToken(response.accessToken);
            }
        } catch (error) {
            console.error("Silent token acquisition failed:", error);
            if (error instanceof InteractionRequiredAuthError) {
                try {
                    const interactiveResponse = await instance.acquireTokenRedirect(request);
                    if (interactiveResponse.accessToken) {
                        this.setAccessToken(interactiveResponse.accessToken);
                    }
                } catch (interactiveError) {
                    console.error("Interactive login failed:", interactiveError);
                }
            }
            this.setState({ isTokenExpired: true });
        }
    }

    setAccessToken = async (token) => {
        localStorage.setItem("accessToken", token);
    }

    setInternalUser = async () => {
        const isInternalUser = await this.checkUser()
        this.setState({ isInternalUser: isInternalUser })
    }

    setAuthCompleted = () => {
        const { isAuthCompleted } = this.state;
        if (!isAuthCompleted) {
            this.setState({ isAuthCompleted: true });
        }
        this.didCheckUser.current = true;
    }

    resize() {
        this.setState({ innerWidth: window.innerWidth })
    }

    componentWillUnmount() {
        if (window.self === window.top)
            window.removeEventListener("focus", this.handleSignOut);
    }

    handleSignOut = async () => {
        const { context } = this;
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
            localStorage.clear();
            context.instance.logoutRedirect();
        }
    }

    toggleErrorDialog = () => {
        this.setState({ showErrorDialog: !this.state.showErrorDialog })
    }

    updateError = (error) => {
        this.setState({ error: error })
    }

    showErrorDialog = (error) => {
        this.toggleErrorDialog();
        this.updateError(error);
    }

    render() {
        if (!this.state.isAuthCompleted) {
            return <Loader />
        }
        document.documentElement.className = "theme-light";

        if (this.state.isTokenExpired) {
            return (
                <SessionExpired />
            )
        }

        if (this.state.innerWidth <= 500 && window.location.pathname !== "/_Authorize") {
            return (
                <Router>
                    <Routes>
                        <Route path="/Signup">
                            <Route path=":signupIdentity" element={<SignUp />} />
                            <Route path="" element={<SignUp />} />
                        </Route>
                        <Route path="*" element={<MobilePage />} />
                    </Routes>
                </Router>
            )
        } else {
            return (
                <GlobalContextProvider>
                    <FeatureFlagProvider>
                        <Suspense fallback={"Loading..."}>
                            {
                                this.state.showErrorDialog &&
                                <ErrorDialog
                                    errorId={this.state.error.id}
                                    errorMessage={this.state.error.message}
                                    toggleErrorDialog={this.toggleErrorDialog} />
                            }
                            <Router>
                                <Routes>

                                    {/* Routes for home page */}
                                    <Route exact path="/" element={<Welcome />} />

                                    {/* Routes for Auth middleware */}
                                    <Route exact path="/_Authorize" element={<AuthMiddleware />} />

                                    {/* Routes for internal iframe to store localstorage between platform */}
                                    <Route exact path="/_AccessStorage" element={<AccessStorage />} />

                                    {/* delete */}
                                    <Route exact path="/GetEarlyAccess" element={<GetEarlyAccess />} />

                                    {/* Routes for custom Signup */}
                                    <Route path="/Signup">
                                        <Route path=":signupIdentity" element={<SignUp />} />
                                        <Route path="" element={<SignUp />} />
                                    </Route>

                                    {/* Routes for custom Signin */}
                                    <Route exact path="/Signin" element={<SignIn />} />

                                    {/* Routes for verifying account */}
                                    <Route exact path="/_VerifyAccount/:userId/:azureId" element={<VerifyAccount />} />

                                    {/* <Route exact path="/_CreateOrganization" element={<CreateOrganizationPage />} /> */}
                                    <Route exact path="/_Workspace/:userEmail/:organizationId" element={<WorkspacePage />} />

                                    <Route exact path="/_WorkspaceCreateApp/:userEmail/:organizationId" element={<WorkspaceCreateAppPage />} />

                                    <Route exact path="/_Integrations/copilot-for-devops/create-app" element={<CreateApp />} />

                                    {/* Routes for inline editing component on runtime */}
                                    <Route exact path="/_Config/:organisationId/:projectId/:instanceId/:entityId/:pageId/:componentId" element={<RuntimeConfigPage />} />

                                    {/* Routes for inline editing menus on runtime */}
                                    <Route exact path="/_Config/:organisationId/:projectId/:instanceId/:portalId" element={<RuntimePortalConfigPage />} />

                                    {/* Routes for inline editing invite user on runtime */}
                                    <Route exact path="/_workspace/inviteOrganizationUsers/:organizationId"
                                        element={
                                            <WorkspaceOrganizationRouteRender>
                                                <WorkspaceInviteUsersPage />
                                            </WorkspaceOrganizationRouteRender>
                                        }
                                    />

                                    {/* Routes for workspace user on runtime */}
                                    <Route exact path="/_workspacesettings/organizationUsers/:organizationId"
                                        element={
                                            <WorkspaceOrganizationRouteRender>
                                                <WorkspaceUserPage />
                                            </WorkspaceOrganizationRouteRender>
                                        }
                                    />

                                    {/* Routes for workspace subscription on runtime */}
                                    <Route exact path="/_workspacesettings/organizationSubscription/:organizationId"
                                        element={
                                            <WorkspaceOrganizationRouteRender>
                                                <WorkspaceSubscriptionPage />
                                            </WorkspaceOrganizationRouteRender>
                                        }
                                    />

                                    {/* Routes for workspace property templates on runtime */}
                                    <Route exact path="/_workspacesettings/tenantInvitation/:organizationId"
                                        element={
                                            <WorkspaceOrganizationRouteRender>
                                                <InvitationPage />
                                            </WorkspaceOrganizationRouteRender>
                                        }
                                    />

                                    {/* Routes for workspace property templates on runtime */}
                                    <Route exact path="/_workspacesettings/propertytemplates/:organizationId"
                                        element={
                                            <WorkspaceOrganizationRouteRender>
                                                <WorkspacePropertyTemplatesPage />
                                            </WorkspaceOrganizationRouteRender>
                                        }
                                    />

                                    {/* Routes for workspace planning templates on runtime */}
                                    <Route exact path="/_workspacesettings/InviteTenantUser/:organizationId"
                                        element={
                                            <WorkspaceOrganizationRouteRender>
                                                <WorkspaceOrganizationTenantUsersPage />
                                            </WorkspaceOrganizationRouteRender>
                                        }
                                    />

                                    {/* Routes for workspace planning templates on runtime */}
                                    <Route exact path="/_workspacesettings/planningtemplates/:organizationId"
                                        element={
                                            <WorkspaceOrganizationRouteRender>
                                                <WorkspaceOrganizationPlanningPage />
                                            </WorkspaceOrganizationRouteRender>
                                        }
                                    />

                                    {/* Routes for workspace recyclebin of projects on runtime */}
                                    <Route exact path="/_workspacesettings/recyclebin/:organizationId"
                                        element={
                                            <WorkspaceOrganizationRouteRender>
                                                <WorkspaceRecyclebinPage />
                                            </WorkspaceOrganizationRouteRender>
                                        }
                                    />

                                    {/* Routes for workspace organization settings on runtime */}
                                    <Route exact path="/_workspacesettings/organizationSettings/:organizationId"
                                        element={
                                            <WorkspaceOrganizationRouteRender>
                                                <WorkspaceOrganizationSettingPage />
                                            </WorkspaceOrganizationRouteRender>
                                        }
                                    />

                                    {/* Routes for workspace app model on runtime */}
                                    <Route exact path="/_workspacesettings/appmodel/:organizationId/projects/:projectId"
                                        element={
                                            <WorkspaceAppModelContextProvider>
                                                <ConfirmationContextProvider>
                                                    <WorkspaceProjectRouteRender>
                                                        <WorkspaceAppModelPage />
                                                    </WorkspaceProjectRouteRender>
                                                </ConfirmationContextProvider>
                                            </WorkspaceAppModelContextProvider>
                                        }
                                    />

                                    {/* Routes for workspace project settings on runtime */}
                                    <Route exact path="/_workspacesettings/appmodel/:organizationId/projects/:projectId/settings"
                                        element={
                                            <WorkspaceProjectRouteRender>
                                                <WorkspaceProjectSettingsPage />
                                            </WorkspaceProjectRouteRender>
                                        }
                                    />

                                    {/* Routes for workspace project settings on runtime */}
                                    <Route exact path="/_workspacesettings/organization/:organizationId/subscription"
                                        element={
                                            <WorkspaceOrganizationRouteRender>
                                                <WorkspacePaymentPage />
                                            </WorkspaceOrganizationRouteRender>
                                        }
                                    />

                                    {/* Routes for Managing Subscription */}
                                    <Route exact path="/_SubscriptionManagement"
                                        element={
                                            <AdminRouteRender>
                                                <SubscriptionPortalPage />
                                            </AdminRouteRender>
                                        }
                                    />

                                    {/* Routes for  showing Pricing page */}
                                    <Route exact path="/_Payment/:organisationId" element={<PricingPage />} />

                                    {/* Routes for 404 page */}
                                    <Route path="*" element={<NoRoutes didCheckUser={this.didCheckUser.current} context={this.context} />} />
                                </Routes>
                            </Router>
                        </Suspense>
                    </FeatureFlagProvider>
                </GlobalContextProvider>
            );
        }
    }
}

export default App;
